
<!-- <div class="d-flex align-items-start justify-content-between alert" *ngIf="(Message | async) as ms" [style.color]="(Type==0)? '#6699ff': (Type==1)? '#fbbf24': '#f87171'" [style.border-color]="(Type==0)? '#6699ff': (Type==1)? '#fbbf24': '#f87171'">
  <span>
    <i class="fa fa-warning mr-2" ></i>
    {{ms}}
  </span>
  <button (click)="closeAlert()" type="button" class="close pl-2">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
 -->

<!-- <div class="d-flex align-items-start justify-content-between alert" *ngIf="(Notification | async)?.message as ms" [style.color]="(Notification | async)?.color" [style.border-color]="(Notification | async)?.color">
  <span [style.color]="(Notification | async).color">
   <i class="fa fa-warning mr-2" ></i>
     {{ms}}
    </span>
</div>
 -->

 <!--  Info = 0, Warning = 1,Error = 2,Success = 3,Shipping = 4, -->
 <div class="d-flex align-items-start justify-content-between alert" *ngIf="(Message | async) as ms"  style="border-color:#6b9df6">
  <span style="color:#6b9df6;">
    <ng-container [ngSwitch]="Type">
      <img *ngSwitchCase="0" style="width: 24px;margin-right:5px;" src="assets/alert-status/info.png">
      <img *ngSwitchCase="1" style="width: 24px;margin-right:5px;" src="assets/alert-status/warning.png">
      <img *ngSwitchCase="2" style="width: 24px;margin-right:5px;" src="assets/alert-status/error.png">
      <img *ngSwitchCase="3" style="width: 24px;margin-right:5px;" src="assets/alert-status/success.png">
      <img *ngSwitchCase="4" style="width: 24px;margin-right:5px;" src="assets/alert-status/shipping.png">
   </ng-container>
    {{ms}}
  </span>
  <button (click)="closeAlert()" type="button" class="close pl-2">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="d-flex align-items-start justify-content-between alert" *ngIf="(Notification | async)?.message as ms" style="border-color:#6b9df6" >
  <span style="color:#6b9df6;">
    <ng-container [ngSwitch]="Type">
        <img *ngSwitchCase="0" style="width: 24px;margin-right:5px;" src="assets/alert-status/info.png">
        <img *ngSwitchCase="1" style="width: 24px;margin-right:5px;" src="assets/alert-status/warning.png">
        <img *ngSwitchCase="2" style="width: 24px;margin-right:5px;" src="assets/alert-status/error.png">
        <img *ngSwitchCase="3" style="width: 24px;margin-right:5px;" src="assets/alert-status/success.png">
        <img *ngSwitchCase="4" style="width: 24px;margin-right:5px;" src="assets/alert-status/shipping.png">
    </ng-container>
     {{ms}}
    </span>
</div>
